import React from 'react';

const ErrorComponent = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <h1 className="display-1 fw-bold mb-4">Unauthorized Access</h1>
        <p className="lead mb-4">
          You are not authorized to view this page. You can return to <a href="/">home</a> or
          contact Elysia support from the help options
        </p>
      </div>
    </div>
  );
};

export default ErrorComponent;
